import WelcomePersona from '@/screens/WelcomePersona';

export default function PrivateWelcomePersonaRoute() {
  return <WelcomePersona />;
}
